<template>
    <div class="card mb-3">
        <div class="card-body">
            <span class="badge badge-pill badge-info">{{perk.tag}}</span>
            <img :src="perk.company.picture" :alt="perk.company.name" v-if="perk.company"/>
            <h3 class="mt-3">{{ perk.name }}</h3>
            <p>{{ perk.description | truncate(70, '...') }}</p>
        </div>
    </div>
</template>

<script>
import CardTemplate from '@/components/global/CardTemplate';

export default {
    name: 'perks-card',

    components: {
        CardTemplate,
    },

    props: {
        perk: {
            type: Object,
            default() {
                return {};
            }
        }
    },
}
</script>

<style scoped>
    .card {
        background-color: #f5f5f7;
        border-radius: 4px;
    }

    img {
        max-width: 100%;
    }
    .badge{
        float: right;
    }
</style>
